import api from './api';

export type ReleaseEnvironment = 'dev' | 'prod';
export type ReleasePlatform = 'android' | 'ios';

export interface DiscoveredRelease {
  id: string;
  environment: ReleaseEnvironment;
  platform: ReleasePlatform;
  source: 'google_play' | 'app_store' | 'testflight' | 'manual';
  version: string;
  build: number;
  status: string;
  statusLabel: string;
  discoveredAt?: string;
  isAvailableToUsers: boolean;
  canApplyPolicy: boolean;
  releaseNotes?: Array<{
    locale: string;
    text: string;
  }>;
}

export interface ReleaseDiscoveryResult {
  environment: ReleaseEnvironment;
  platform: ReleasePlatform;
  channelLabel: string;
  appName?: string;
  appIdentifier?: string;
  releases: DiscoveredRelease[];
  syncedAt: string;
  note?: string;
}

export async function getDiscoveredReleases(
  env: ReleaseEnvironment,
  platform: ReleasePlatform,
  refresh = false,
): Promise<ReleaseDiscoveryResult> {
  const response = await api.get('/api/releases/discovery', {
    params: { env, platform, ...(refresh ? { refresh: true } : {}) },
  });
  return response.data.data;
}
